package com.bikompanion.domain

data class BikeNetwork(
    val id: String,
    val name: String,
    val latitude: Double,
    val longitude: Double,
    val city: String,
    val country: String,
    /** Operators behind the network — often one, sometimes a consortium, occasionally none. */
    val company: List<String> = emptyList(),
    /** Where the network's data comes from — its API path, or its feed's discovery document. */
    val href: String = "",
    val licenseName: String = "",
    val licenseUrl: String = "",
    /**
     * The ground this network serves, once it is known.
     *
     * Null where the source doesn't say — CityBikes describes a network by a single point, so
     * everything falls back to that point sitting inside the viewport. Sources that publish
     * their stations up front can do better, and callers that can use the real area should
     * prefer it: a network whose centre is off screen may still have half its docks in view.
     */
    val coverage: NetworkCoverage? = null,
)
